import * as React from "react";
const Svg16PxText = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.31 1.57v3.49h1.13v-2.4h4.99v10.7h-2.5v1.09h6.12v-1.09h-2.5V2.65h4.99v2.4h1.13V1.57z", style: {
  fill: "currentColor"
} }));
export default Svg16PxText;
